(function (QLD) {
  "use strict";

  /**
   * @module locationAllowModal
   */
  var locationAllowModal = {};

  /**
   * Initialise the modal for setting location permissions
   *
   * @memberof module:locationAllowModal
   */
  locationAllowModal.init = function () {
    const locationModal = document.getElementById("modal--allow-geolocate");

    if (locationModal) {
      QLD.Modal.open(locationModal);

      const allowBtn = locationModal.querySelector(
        '[data-action="allow-location"]',
      );
      const denyBtn = locationModal.querySelector(
        '[data-action="deny-location"]',
      );

      if (allowBtn) {
        allowBtn.addEventListener("click", function () {
          const errorCallback = function () {
            allowBtn.outerHTML =
              '<p class="qld__input--error">Unable to locate</p>';
          };
          QLD.utils.geolocateUser(true, errorCallback);
        });
      }

      if (denyBtn) {
        denyBtn.addEventListener("click", function () {
          QLD.utils.setLocalStorage("deny-location", true);
        });
      }
    }
  };

  var QLD = QLD || {};
  QLD.locationAllowModal = locationAllowModal;
  window.QLD = QLD;

  document.addEventListener("DOMContentLoaded", function () {
    // Trigger modal if location not set
    if (
      (!QLD.utils.getLocalStorage("qld_user_location") ||
        QLD.utils.getLocalStorage("qld_user_location") === null) &&
      !QLD.utils.getLocalStorage("deny-location")
    ) {
      setTimeout(() => QLD.locationAllowModal.init(), 1000);
    }
    // Plain JS: append "*" to query before submitting
    const searchForm = document.getElementById("search-form-sf-top-services");
    if (searchForm) {
      searchForm.addEventListener("submit", function (e) {
        let visibleInput = searchForm.querySelector(".tt-input");
        let hiddenInput = searchForm.querySelector("input[name='query']");
        let targetInput = visibleInput?.value ? visibleInput : hiddenInput;

        if (!targetInput) return;

        let val = targetInput.value.trim();

        // If empty, set to "!padrenul"
        if (!val) {
          val = "!padrenul";
        }
        // Otherwise, append "*" if missing
        else if (!val.endsWith("*")) {
          val += "*";
        }

        targetInput.value = val;

        // Make sure hidden input matches visible input if needed
        if (visibleInput && hiddenInput) hiddenInput.value = visibleInput.value;
      });
    }
  });
})(window.QLD);
